import { BrowserRouter, Route, Routes } from 'react-router-dom';
import QuoteView from './pages/QuoteView';
import Confirmation from './pages/Confirmation';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/quotes/:token" element={<QuoteView />} />
        <Route path="/quotes/:token/confirmation" element={<Confirmation />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
